/*eslint complexity: off*/
import React, {
  useContext,
  useEffect,
  useState
}                           from 'react';
import { useTranslation }   from 'react-i18next';
import moment               from 'moment';
import Send                 from '@material-ui/icons/Send';
import {
  sendPush,
  createPush,
  editPush,
}                           from '~/config/routes';
import { toast }            from 'react-toastify';
import { historyPropType }  from '~/config/routerPropTypes';
import Request              from '~/providers/Request';
import Context              from './context';
import Paper                from '~/components/Paper';
import ModalDelete          from '~/components/ModalDelete';
import InputShow            from '~/components/InputShow';
import PaperButtons         from '~/components/PaperButtons';
import PushRecord           from '~/records/PushRecord';
import GridContainer        from '~/components/GridContainer';
import GridItem             from '~/components/GridItem';
import FormControlLabel     from '@material-ui/core/FormControlLabel';
import Radio                from '@material-ui/core/Radio';
import RadioGroup           from '@material-ui/core/RadioGroup';
import Button               from '~/components/Button';
import { AbilityContext }   from '~/contexts/Can';

const attrName = (attr) => PushRecord.hummanAttributeName(attr);

function ShowPush({history}) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [ record, setRecord ] = useState(new PushRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const [language, setLanguage] = useState('pt');
  const [sentNotifications, setSentNotifications] = useState(0);
  const languageObject = {
    pt: '',
    en: '_en',
    es: '_es',
  };
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord(record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/push_messages/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/push_messages/${id}`)
    .then(() => {
      toast.success(t('delete-toast-success'));
      history.push(sendPush.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('delete-toast-fail'));
    });
    setModal(false);
  }

  const languageHandler = (attr) => `${attr}${languageObject[language]}`;

  const handleRadio = event => setLanguage(event.target.value);

  function renderImage(){
    if(record.get('image'))
      return <img src={record.getImageUrl()} style={{maxWidth: 400}} />;
  }

  const sendAlready = moment().isSameOrBefore(record.get('send_at'));
  return (
    <Paper
      Icon={ Send }
      iconColor="blue"
      title={t('push.defSingular')}
      loading={ loading }
      actions={sendAlready ?
        <PaperButtons
          id={ id }
          setModal={ability.can('delete', 'Pushs') ? setModal : null}
          backRoute={ sendPush }
          newRoute={ability.can('new', 'Pushs') ? createPush : null}
          editRoute={ability.can('edit', 'Pushs') ? editPush : null}
        /> : null}
      >
          <GridContainer>
          <GridItem xs={12} md={12}>
                <RadioGroup aria-label="position" name="position" value={language} onChange={handleRadio} row>
                  <FormControlLabel
                    value="pt"
                    control={<Radio color="primary" />}
                    label="PT-BR"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="en"
                    control={<Radio color="primary" />}
                    label="EN"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="es"
                    control={<Radio color="primary" />}
                    label="ES"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </GridItem>
            <GridItem xs={8} md={4}>
              <InputShow
                label={attrName(languageHandler('title'))}
                value={record.get(languageHandler('title'))}
              />
            </GridItem>
            <GridItem xs={8} sm={10} md={4}>
              <InputShow
                value={record.get(languageHandler('subtitle'))}
                label={attrName(languageHandler('subtitle'))}
              />
            </GridItem>
            <GridItem xs={8} sm={10} md={3}>
              <InputShow
                value={moment(record.get('send_at')).format('LLL')}
                label={attrName('send_at')}
              />
            </GridItem>
            <GridItem xs={12} sm={9}>
              <InputShow
                value={ record.get(languageHandler('message')) }
                label={attrName(languageHandler('message'))}
              />
            </GridItem>
            <GridItem xs={12} sm={6}>
              <InputShow
                value={ record.get('link_url') }
                label={attrName('link_url')}
              />
            </GridItem>
            <GridItem xs={12} sm={6}>
              <InputShow
                value={record.get('image_url')}
                label={attrName('image_url')}
              />
            </GridItem>
            <GridItem xs={8} sm={10} md={8}>
              {renderImage()}
            </GridItem>
          </GridContainer>
        <ModalDelete
          modal={modal}
          onClose={() => {
            setModal(false);
          }}
          name={record.get('name')}
          id={record.get('id')}
          deleteAction={handleDelete}
        />
      </Paper>
  );
}

  ShowPush.propTypes={
    history: historyPropType,
  };

export default ShowPush;
